module.exports = __webpack_public_path__ + "static/img/3.ed9802b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-contrastistas-proveedores/3.png
// module id = jI4K
// module chunks = 0